import * as React from 'react';

import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import Routes, { FacilityRoutes } from 'constants/Route';
import configureStore from './store/configureStore';
import { ApplicationState } from 'store/definitions';

import { Route, generatePath, matchPath, match } from 'react-router';
import DemandPage from 'pages/Demand';
import Revenue from 'pages/Revenue';
import PricingPage from 'pages/Pricing';
import DateAdminPage from './pages/admin/Dates';
import UserAdminPage from './pages/admin/Users';
import EVPriceView from './containers/EVPriceView';
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components';
import { defaultTheme } from 'constants/Theme';
import JTest from 'pages/Scratchpad/JTest';
import { ModalProvider } from 'components/Modal/useModalStack';
import { Facility, FacilityFlag, UISettings } from 'store/uiSettings/reducer';
import NavBar from 'constants/AppNavBar';
import { Zone, ZoneFlag } from 'store/zone/reducer';
import { initialUIState } from 'store/ui/reducer';
import { graphDataUpdater_2_0 } from 'store/updater_2_0';
import { FacilityPageProps } from 'topdefinitions';
import { facilityRouteQuery } from 'store/router/selector';

const GlobalStyles = createGlobalStyle`
* {
    box-sizing: border-box;
    font-family: 'Roboto', sans-serif !important;
}
#root{
  padding:20px 100px;
}

button:focus {
  outline: 0;
}
`;

const AppWrap = styled.div`
  background-color: ${({ theme }) => theme.palette.text.bg};
  font-size: 16px;
  color: ${({ theme }) => theme.palette.text.fg};
`;
const Footer = styled.div`
  line-height: 50px;
  border-top: 1px solid rgb(216, 216, 216);
  margin-top: 80px;
`;

const TestC: React.FC<{}> = (props) => {
  console.log('Facilities props?', props);
  return <div>Facilties:{JSON.stringify(props)}</div>;
};
const RestC: React.FC<{}> = (props) => {
  console.log('Rest props?', props);
  return <div>Rest:{JSON.stringify(props)}</div>;
};

const AppRoot = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <GlobalStyles />
      <ModalProvider>
        <NavBar />
        <AppWrap>
          {/* <Route path={Routes.Facilities} component={TestC} /> */}
          <Route path={Routes.AdminUsers} component={UserAdminPage} />
          <Route path={Routes.AdminDates} component={DateAdminPage} />
          <Route path={Routes.FacilityRevenue} component={Revenue} />
          <Route path={Routes.FacilityZRevenue} component={Revenue} />
          <Route path={Routes.FacilityDemand} component={DemandPage} />
          <Route path={Routes.FacilityZDemand} component={DemandPage} />
          <Route path={Routes.FacilityPricing} component={PricingPage} />
          <Route path={Routes.FacilityZPricing} component={PricingPage} />
          <Route path={Routes.EVPriceGraph} component={EVPriceView} />
          <Route path={Routes.EVPriceZGraph} component={EVPriceView} />
          {/* <Route exact path={Routes.Revenue} component={Revenue} />
          <Route exact path={Routes.Pricing} component={PricingPage} /> */}
          {/* <Route exact path={Routes.Demand} component={DemandPage} /> */}
          <Route exact path={Routes.JTest} component={JTest} />
          <Route path={'/{:rest}'} component={RestC} />
        </AppWrap>
        <Footer>
          <div>Powered by BlackCube Predictions AB</div>
        </Footer>
      </ModalProvider>
    </ThemeProvider>
  );
};

const alterZone = (zone: Zone) => {
  zone.zoneFlags = [];
  if (!!zone.config) {
    if (zone.config.IsElectric) {
      zone.zoneFlags.push(ZoneFlag.Electric);
    }
  }
};

const alterFacility = (facility: Facility) => {
  facility.facilityFlags = [];
  switch (facility.id) {
    case 18:
    //   facility.facilityFlags = [FacilityFlag.NoFutureGraphDisplay];
    //   break;
    default:
      break;
  }
};

export default async () => {
  const baseUrl = '/';

  const history = createBrowserHistory({ window, basename: baseUrl } as any);

  const setup = (initialData?: ApplicationState) => {
    console.log({
      ...initialData,
    });
    const match = matchPath<FacilityPageProps['match']['params']>(
      window.location.pathname,
      facilityRouteQuery
    );
    var _firstFac = initialData?.uiSettings.sites.find(
      (f) => f.path === match?.params.facilityId
    );

    if (!!initialData?.uiSettings) {
      initialData.uiSettings.sites.forEach((facility) => {
        alterFacility(facility);
      });
    }

    if (!!initialData?.zoneData) {
      initialData!.zoneData!.forEach((zone: Zone) => {
        alterZone(zone);
      });
    }
    console.log(initialData?.uiSettings.sites);

    const firstFacility = !!_firstFac
      ? _firstFac
      : initialData?.uiSettings.sites[0];
    let firstActiveFacilityRoute = firstFacility!.path;
    let tmpMatch: match<{
      facilityId: string | undefined;
      zoneId?: string;
    }> | null;
    let uiOverride = {
      activeFacility: firstFacility!.path,
      activeZoneID: null,
    } as {
      activeFacility?: string;
      activeZoneID: number | string | null;
    };
    if (history.location.pathname === '/') {
      var pathData = {
        facilityId: firstFacility!.path,
      } as { facilityId: string; zoneId?: number };
      var facilityZones = initialData?.uiSettings.siteZones.filter(
        (f) => f.routePath === firstFacility?.path
      );
      console.log(facilityZones);
      if (facilityZones?.length === 1) {
        pathData.zoneId = facilityZones[0].zoneId;
      } else if (!!facilityZones && facilityZones!.length > 5) {
        pathData.zoneId = facilityZones[0].zoneId;
      }
      if (!!pathData.zoneId) {
        history.replace(generatePath(Routes.FacilityZRevenue, pathData));
      } else {
        history.replace(generatePath(Routes.FacilityRevenue, pathData));
      }
    } else if (
      (tmpMatch = matchPath(history.location.pathname, {
        path: FacilityRoutes,
      })) &&
      tmpMatch?.path !== Routes.Facilities
    ) {
      if (!!tmpMatch.params.zoneId) {
        uiOverride.activeZoneID = tmpMatch.params.zoneId!;
      }
    } else if (
      (tmpMatch = matchPath(history.location.pathname, {
        path: Routes.Facilities,
      }))
    ) {
      uiOverride.activeFacility = tmpMatch.params.facilityId!;
      if (!!tmpMatch.params.zoneId) {
        uiOverride.activeZoneID = tmpMatch.params.zoneId;
      }
      history.replace(generatePath(Routes.FacilityRevenue, tmpMatch.params));
    }

    const store = configureStore(history, [graphDataUpdater_2_0], {
      ...initialData,
      uiState: {
        ...initialUIState,
        ...uiOverride,
      },
    } as Partial<ApplicationState> as any);

    // Store a "global" window copy of the store so we can access it from the devtools.
    (window as any).tpStore = store;
    console.log(store);
    // Get the application-wide store instance, prepopulating with state from the server where available.

    ReactDOM.render(
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <AppRoot />
        </ConnectedRouter>
      </Provider>,
      document.getElementById('root')
    );
  };

  try {
    let uiSettingsResult = await fetch('/api/priceui/v3/uisettings', {
      redirect: 'manual',
    });
    console.log('UI-settings result,', uiSettingsResult);
    if (!uiSettingsResult.ok) {
      if (uiSettingsResult.status === 401) {
        // need login
        window.location.href =
          '/user/login?returnUrl=' +
          encodeURIComponent(window.location.pathname.toString());
        return;
      }
    }
    let uiSettings = (await uiSettingsResult.json()) as UISettings;
    console.log('Downloaded UISETTINGS:', uiSettings);
    // TODO: massage stuff for initial-props
    setup({
      uiSettings: { ...uiSettings, isAPDemo: false },
      eventData: uiSettings.events,
      zoneData: uiSettings.siteZones.map((sz) => {
        var pricings = uiSettings.pricings.filter(
          (f) => f.parentZoneId === sz.zoneId
        );
        var selected = uiSettings.pricings.find(
          (f) => f.parentZoneId === sz.zoneId && f.selected === true
        );
        return {
          id: sz.zoneId,
          name: sz.zoneName,
          sitePath: sz.routePath,
          aggressivity: 3,
          pricings: pricings,
          exports: sz.exports,
          selectedPricing: !selected ? null : selected.id,
          config: sz.config,
        } as Zone;
      }),
    } as Partial<ApplicationState> as any);
  } catch (e) {
    console.log(e);
    alert('Load error, reloading');
    window.location.reload();
    return;
  }
  // no initial-data.
  //setup(undefined);
};
